/* Sticky add-to-cart bar for mobile product pages.
   Appears once the real Purchase Options block scrolls out of view, and
   simply forwards the click to it — so there is only ever one cart path. */
(function () {
  'use strict';

  var target = document.querySelector('[data-dpo-add]');
  if (!target) return;

  var bar = document.querySelector('[data-dv-sticky]');
  if (!bar) return;

  var btn = bar.querySelector('.dv-sticky__btn');
  if (btn) btn.addEventListener('click', function () { target.click(); });

  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      bar.classList.toggle('is-visible', !e.isIntersecting);
    });
  }, { rootMargin: '0px 0px -80px 0px' });

  io.observe(target);
})();
